import { WIR } from 'types/wellGuardian';

export const getIsUnplannedReactiveScope = (wir: WIR | null) => {
  return wir?.isUnplannedReactiveScope;
};
